// Next.js 16 client-side instrumentation — runs once when the app boots in
// the browser. Doc :
// node_modules/next/dist/docs/01-app/03-api-reference/03-file-conventions/instrumentation-client.md
//
// Pourquoi ce fichier (et pas `sentry.client.config.ts`) ? Sous Turbopack
// (default Next.js 16), `sentry.client.config.ts` est inactif — il faut
// passer par instrumentation-client.ts (cf
// feedback_nextjs16_turbopack_sentry_client).
//
// Le DSN est exposé via `NEXT_PUBLIC_SENTRY_DSN` côté browser (différent de
// `SENTRY_DSN` server-only). Activé uniquement si la variable est définie.

import * as Sentry from "@sentry/nextjs";

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NODE_ENV ?? "production",
    release: process.env.NEXT_PUBLIC_APP_VERSION ?? "dev",
    tracesSampleRate: 1.0,
    // Replay et browser tracing désactivés au démarrage — bruit + bande passante.
    // Activer ciblé plus tard si on traque un bug user-visible spécifique.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}
